import React, { Component } from "react";
import EmployeeList from "./EmployeeList";
import styles from "../../dist/crew-app.css";
import appRequest from "../utilities/appRequest";

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: "mobile",
      desktop: "(min-width: 768px)",
      tablet: "(max-width: 767px)",
      mobile: "(max-width: 479px)",
      crewContent: [],
      status: "idle",
      // crewContent: [
      //   {
      //     firstName: "Mike",
      //     lastName: "Rhoads",
      //     thumb: "img/mike.jpg",
      //     bio: "Our Director of Operations, Michael Rhoads, has more than three decades of experience in the aviation industry both as a pilot and a mechanic. Michael has worked in Southeast Alaska for  various carriers. Prior to his latest positions Michael was Chief Pilot and Check Airman for Ketchikan Air in Ketchikan, Alaska. A Flight Safety Instructor in the MetroLiner with the authorization to perform 135 checks in the Simulator. Michael has over 20,000 hours of total flight time, he is a certified flight and ground instructor and is type rated in the G-73, G-73T, Lear Jet, and the Lockheed Hercules. Michael has served three terms while appointed to the AACA Board of Directors and has enjoyed learning the processes involved.",
      //     position: "Director of Operations",
      //   },
      //   {
      //     firstName: "Tom",
      //     lastName: "Swartwood",
      //     thumb: "img/tom-swartwood.jpg",
      //     bio: "Tom Swartwood got his private pilots license while in high school in 1987. He has flown over 13,000 hours and is type-rated in Saab 340 turboprops, Embraer jets, and Canadair jets. He runs a family business in Lynden, WA , and when not flying for Point to Point, he can be found flying the Murphy Rebel he built.",
      //     position: "Chief Pilot",
      //   },
      //   // {
      //   //   firstName: "Grant",
      //   //   lastName: "Hasting",
      //   //   thumb: "img/grant-hasting.jpg",
      //   //   bio:
      //   //     "With experience spanning over the last decade, Grant has a diverse background in aviation. Prior to working for Point To Point, Grant has served roles as company instructor, Captain, and First Officer. Grant has spent time flying freight throughout the US with much time spent in the Pacific Northwest. Additionally, he has experience flying passenger airline service throughout North America. Grant has over 4,000 hours of flight time, is a certified flight and ground instructor, and holds the highest level of pilot certification, the airline transport pilot certificate. Outside of flying, Grant enjoys to get out and enjoy the great Pacifc Northwest by hiking, skiing, and camping.",
      //   //   position: "Chief Pilot",
      //   // },
      //   {
      //     firstName: "Ron",
      //     lastName: "Bellamy",
      //     thumb: "img/ron.jpg",
      //     bio: "Having been a sailor for many years in my early adult years I easily became fascinated with flying gliders as well. It was similar to sailing in so many ways. I have enjoyed the world of aviation ever since having studied, practiced and flown in a wide variety of single and multi-engine aircraft, gliders, classic taildraggers, tricycle gear, high wing, low wing, reciprocating and turbo-props, and jets. The world of aviation is such a progressive, contemporary adventure that there seems to be no end to what I can explore. I have advanced to being an instructor and have flown and towed gliders, guided the commuters as a skywatch pilot and carried banners across the skies.",
      //     position: "Pilot",
      //   },

      //   // {
      //   //     firstName: "Tim",
      //   //     lastName: "Martin",
      //   //     thumb: "img/tim-martin.jpg",
      //   //     bio:'Tim attended LeTourneau University school of Aeronautics in eastern Texas where he studied aviation. Shorty after graduating, Tim was hired to fly the corporate sector of aviation in aircraft ranging from small pistons to entry level business jets.  After other life opportunities brought Tim and his wife to Washington state, he quickly started flying for Point to Point where he continues to do what he loves.',
      //   //     position: "Pilot",
      //   //   },

      //   {
      //     firstName: "Bob",
      //     lastName: "Harrison",
      //     thumb: "img/bob-harrison.jpg",
      //     bio: "Bob flew with America West Airlines, is the Chief Flight Instructor for Cascade Aviation, worked at Skycorp Jet Charters and is a retired Naval Aviator. He lives in Oak Harbor with his wife and is a school bus operator.",
      //     position: "Pilot",
      //   },
      //   // {
      //   //   firstName: "Sam",
      //   //   lastName: "Sedivy",
      //   //   thumb: "img/sam-sedivy.jpg",
      //   //   bio:
      //   //     "I was born in Southern California and only ever wanted to fly. I grew up reading, watching and learning everything about aviation. I started flying in Arizona with Embry-Riddle Aeronautical University. From there, I continued flying in Southern California in airplanes as well as helicopters. And if I wasn't flying them, I was jumping out of them!  I really got my flying experience in the Pacific Northwest when I moved to Washington. I've flown all over North America in small planes as well as commercial jets and have spent a bit of time in Alaska. Outside of flying I stay active hiking, camping, climbing, and snowboarding.",
      //   //   position: "Pilot",
      //   // },
      //   // {
      //   //   firstName: "James",
      //   //   lastName: "Simon",
      //   //   thumb: "img/james-simon.jpg",
      //   //   bio:
      //   //     "Born in the Pacific Northwest into an aviation family, airplanes have always been an integral part of James’ life. In 2013 he earned his pilot’s license. An outdoorsman at heart, James and his family spend a couple weeks a year flying and camping in the Idaho backcountry in their Cessna 182. When not taking to the skies, James spends his time with his wife and kids and works as web developer for a non-profit organization in Federal Way, WA.",
      //   //   position: "Pilot",
      //   // },

      //   {
      //     firstName: "Steve",
      //     lastName: "Nordstrand",
      //     thumb: "img/steve-nordstrand.jpg",
      //     bio: "Steve’s interest in aviation seems to run in his genes. His father was an aircraft mechanic in WW2. Steve, a Navy Veteran, carried on the tradition by becoming an aircraft mechanic. His son continued by becoming a captain for Allegiant Airlines. Steve has called the North-West home since 1977. He is a commercially rated pilot that has recently returned to the area after flying tourists over the Grand Canyon. He earned his private pilot license in 2007 and has continued to gain ratings over the years. Steve learned to fly out of the Oak Harbor Air Park and has his own twin engine airplane. He is looking forward to safely flying you to your destination.",
      //     position: "Pilot",
      //   },
      //   {
      //     firstName: "Andreas",
      //     lastName: "Munson",
      //     thumb: "img/andreas-munson.jpg",
      //     bio: "",
      //     position: "Pilot",
      //   },
      //   {
      //     firstName: "Roger",
      //     lastName: "Rowland",
      //     thumb: "img/roger-rowland.jpg",
      //     bio: "I enjoy flying, hiking, hunting, snowboarding and anything I can ride from dirt bikes to ATV’s.  I hold a commercial, multi engine, instrument and flight instruction ratings.",
      //     position: "Pilot",
      //   },
      //   {
      //     firstName: "Trevor",
      //     lastName: "Adams",
      //     thumb: "img/trevor-adams.jpg",
      //     bio: "",
      //     position: "Pilot",
      //   },
      //   {
      //     firstName: "Kathryn",
      //     lastName: "Perry",
      //     thumb: "img/kathyrn-perry.jpg",
      //     bio: "",
      //     position: "Pilot",
      //   },
      //   {
      //     firstName: "Miguel",
      //     lastName: "Marmol",
      //     thumb: "img/miguel-marmol.jpg",
      //     bio: "More information will be provided at a later date.",
      //     position: "Pilot",
      //   },
      //   // {
      //   //   firstName: "Mark",
      //   //   lastName: "Mount",
      //   //   thumb: "img/mark-mount1.jpg",
      //   //   bio:
      //   //     "I was born in Port Townsend, Washington and grew up in the Shoreline area north of Seattle. I attended Big Bend Community College in Moses Lake and earned my Commercial Pilot's License. I graduated from Central Washington University with a Bachelor of Arts Degree in Aerospace Management and completed that degree with an Executive Internship at SeaTac International Airport. I flew for and managed a charter and scheduled floatplane operation based out of Lake Union and accumulated over 2,000 hours flying throughout the Pacific Northwest, British Columbia, and as far as Fairbanks, Alaska. I also flew the River's Inlet contract for a floatplane operation based out of Renton. I look forward to sharing my experience and passion for flying with the clients of Point to Point Air.",
      //   //   position: "Pilot",
      //   // },
      //   {
      //     firstName: "Diana",
      //     lastName: "Trofimovich",
      //     thumb: "img/diana.jpg",
      //     bio: "Diana started flying in 2013 when she was working at a flight school in Puyallup, Washington. In 2014, she received her Private Pilots Certificate and then went on to get her Bachelor's degree in Aviation Management. After finishing college, Diana decided to finish her Instrument and Commercial ratings and work on becoming a professional pilot. She's currently flying for Point to Point Air and enjoys being able to fly in the Pacific Northwest. Aside from flying, Diana likes to bake and travel to new places. One of her favorite places is Vail, Colorado.",
      //     position: "Pilot",
      //   },
      //   // {
      //   //   firstName: "Brittney",
      //   //   lastName: "Wyman",
      //   //   thumb: "img/brittney-wyman.jpg",
      //   //   bio:
      //   //     "Watching the Blue Angels perform is where my passion for aviation began. After seeing them perform I knew I had to fly. I started flying at a young age and I am working towards becoming a professional pilot. I have worked at Boeing Field with private jets and general aviation planes. I work for Point To Point Air now and I couldn’t be any happier. I enjoy talking with our customers and sharing the passion of flight. I look forward to speaking with you to book your next flight!",
      //   //   position: "Administrative Assistant",
      //   // },
      //   {
      //     firstName: "Lenora",
      //     lastName: "Fenstermaker",
      //     thumb: "img/lenora-fenstermaker.jpg",
      //     bio: "Hi! I am your friendly Customer Service Representative eagerly awaiting to assist you in booking the trip of a life time. My love for life above the clouds began in my early 20’s, when I was out hiking in the Cascades every chance I could get. There is nothing like being at the top of a mountain on a clear day- you can see forever! And then at age 30, I fell into skydiving…  In total, I have 250 jumps from perfectly good airplanes. There is nothing like jumping out of a plane at 14,000 feet with just a couple of parachutes to save your life! And then they let me fly the plane… Needless to say, my adventures have not ended. Let me help create an amazing adventure for you!",
      //     position: "Administrative Assistant",
      //   },
      // ],
    };
  }
  componentDidMount() {
    this.setState({ status: "loading" });
    appRequest
      .getAllPilots()
      .then((resp) => {
        this.setState({ crewContent: resp.responseAry, status: "ready" });
      })
      .catch((err) => {
        this.setState({ status: "error" });
      });
  }

  componentWillUnmount() {}
  render() {
    if (this.state.status == "ready") {
      return (
        <section>
          <div className="flex">
            <h2>Meet our Team</h2>
            <a className="cta-btn ghost" href="/about-contact.php">
              Join our team
            </a>
          </div>
          <EmployeeList {...this.state} />
        </section>
      );
    }
    if (this.state.status == "loading") {
      return (
        <section>
          <div className="flex">
            <h2>Meet our Team</h2>
            <a className="cta-btn ghost" href="/about-contact.php">
              Join our team
            </a>
          </div>
          Loading ...
        </section>
      );
    }
    if (this.state.status == "idle") {
      return (
        <section>
          <div className="flex">
            <h2>Meet our Team</h2>
            <a className="cta-btn ghost" href="/about-contact.php">
              Join our team
            </a>
          </div>
          Loading ...
        </section>
      );
    }
    if (this.state.status == "error") {
      return (
        <section>
          <div className="flex">
            <h2>Meet our Team</h2>
            <a className="cta-btn ghost" href="/about-contact.php">
              Join our team
            </a>
          </div>
          An error occured. Please try again later.
        </section>
      );
    }
  }
}
export default App;
